import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/notifications/pageList';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { page = 1, perPage = 50, unread = false } = action?.payload || {};
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('per_page', String(perPage));
    if (unread) params.set('unread', 'true');
    const response = yield call(
      axios.get,
      `${config.API_URL}/notifications/?${params.toString()}`,
      { headers: getLocalUser() },
    );
    // { items, pagination: { total, ... }, unread_count }
    yield put(fetchSuccess(response.data?.data ?? response.data ?? {}));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
